const compatModules = {};import * as Mod1 from "./discourse/admin-chat-integration-plugin-route-map";
compatModules["discourse/admin-chat-integration-plugin-route-map"] = Mod1;

export * as discourse$admin__chat__integration__plugin__route__map$$__module from "./discourse/admin-chat-integration-plugin-route-map";
export {
default as discourse$admin__chat__integration__plugin__route__map$$default
} from "./discourse/admin-chat-integration-plugin-route-map";
import * as Mod2 from "./discourse/initializers/chat-integration-admin-plugin-configuration-nav";
compatModules["discourse/initializers/chat-integration-admin-plugin-configuration-nav"] = Mod2;

export * as discourse$initializers$chat__integration__admin__plugin__configuration__nav$$__module from "./discourse/initializers/chat-integration-admin-plugin-configuration-nav";
export {
default as discourse$initializers$chat__integration__admin__plugin__configuration__nav$$default
} from "./discourse/initializers/chat-integration-admin-plugin-configuration-nav";
import * as Mod3 from "./discourse/public-route-map";
compatModules["discourse/public-route-map"] = Mod3;

export * as discourse$public__route__map$$__module from "./discourse/public-route-map";
export {
default as discourse$public__route__map$$default
} from "./discourse/public-route-map";
import * as Mod4 from "./discourse/routes/transcript";
compatModules["discourse/routes/transcript"] = Mod4;

export * as discourse$routes$transcript$$__module from "./discourse/routes/transcript";
export {
default as discourse$routes$transcript$$default
} from "./discourse/routes/transcript";
export default compatModules;
